import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IFollowUpTaskAttachment } from "../../utils/types/models";

export default createEntityReducer<IFollowUpTaskAttachment>(Endpoint.FollowUpTaskAttachments, Endpoint.FollowUpTaskAttachmentsList);
